import Autocomplete from "@saleor/components/AutocompleteForObject";
import useLocalPaginator, {
  useLocalPaginationState
} from "@saleor/hooks/useLocalPaginator";
import uniqBy from "lodash/uniqBy";
import React, { useEffect, useRef, useState } from "react";
interface IProps {
  id?: string;
  handleSelectedSearch?: (value: any) => void;
  handleCheckAddedValue?: (event: any) => void;
  placeholder?: string;
  isClean?: boolean;
  contained: boolean;
  totalCount?: number;
  dataOptions: any[];
  error?: boolean;
  objectSuggestion?: boolean;
  defaultInputValue?: string;
  defaultValue?: any;
  withNonSelect?: boolean;
  disabled?: boolean;
  pageInfo?: any;
  showLoadMore?: boolean;
  disableDuplicationLoading?: boolean;
  onMouseLeave?(event: any);
}

interface LastItemParamsProps {
  id: string;
  position: number;
}

const StaticInputSuggestion: React.FC<IProps> = (props: IProps) => {
  const {
    id,
    handleSelectedSearch,
    handleCheckAddedValue,
    placeholder,
    isClean,
    contained,
    totalCount,
    dataOptions,
    error,
    objectSuggestion,
    onMouseLeave,
    defaultInputValue,
    defaultValue,
    withNonSelect,
    disabled,
    pageInfo,
    showLoadMore,
    disableDuplicationLoading
  } = props;

  const firstRender = useRef(true);
  const [value, setValue] = useState<string>("");
  const [opts, setOpts] = useState<any[]>([]);
  const [
    valuesPaginationState,
    setValuesPaginationState
  ] = useLocalPaginationState(100);
  const paginateValues = useLocalPaginator(setValuesPaginationState);
  const { loadNextPage } = paginateValues(pageInfo, valuesPaginationState);
  const [lastItemParams, setLastItemParams] = useState<LastItemParamsProps>(
    null
  );

  useEffect(() => {
    if (firstRender.current && !value && defaultInputValue && defaultValue) {
      setValue(defaultInputValue);
      firstRender.current = false;
    }
  }, [defaultInputValue, defaultValue, firstRender.current]);

  const handleChange = event => {
    if (handleCheckAddedValue) {
      handleCheckAddedValue(event);
    }
    setValue(event);
  };

  const onLastItemVisible = (id: string, position: number) => {
    setLastItemParams({ id, position });
    loadNextPage();
  };

  useEffect(() => {
    // check the item that already remove duplicate from BE or not
    if (!disableDuplicationLoading) {
      const uniqOpts = uniqBy([...opts, ...dataOptions], "value");
      setOpts(uniqOpts);
    } else {
      setOpts(dataOptions);
    }

    if (lastItemParams?.id) {
      setTimeout(() => {
        const { id: lastItemId, position } = lastItemParams;
        const el = document.getElementById(lastItemId);
        if (el) {
          el.scrollTo({ top: position });
        }
      }, 100);
    }
  }, [dataOptions]);

  useEffect(() => {
    setLastItemParams(null);
  }, [value]);

  const suggestedResult = opts?.filter(option => {
    const searchValue = value?.toLowerCase();
    return (
      option.value.toLowerCase().includes(searchValue) ||
      option.title.toLowerCase().includes(searchValue)
    );
  });

  return (
    <div>
      <Autocomplete
        id={id}
        data-testid={id}
        contained={contained}
        defaultInputValue={defaultInputValue}
        optionsProp={opts}
        placeholderProps={placeholder}
        totalCount={totalCount || suggestedResult?.length || opts?.length}
        onLastItemVisible={showLoadMore && onLastItemVisible}
        onChangeProps={e => {
          handleChange(e);
          if (withNonSelect) {
            handleSelectedSearch(e);
          }
        }}
        onSearch={handleSelectedSearch}
        objectSuggestion={objectSuggestion}
        isReset={isClean}
        defaultValue={defaultValue}
        onMouseLeave={onMouseLeave}
        error={error}
        disabled={disabled}
      />
    </div>
  );
};

export default StaticInputSuggestion;
